import { CustomSlugDTO } from '../dto/slug/customSlug.dto';
import { MODE_FALLBACK_ORDER } from '../constants/responsive-modes';

export class CustomSlug {
  public slug: string;
  id?: number;
  uuid: string;
  static_template_uuid: { [mode: number]: string | null } = {1: null, 2: null, 3: null};
  dynamic_template_uuid: { [mode: number]: string | null } = {1: null, 2: null, 3: null};
  isDevelopment: boolean = false;

  constructor(
    slug: string, 
    static_template_uuid?: { [mode: number]: string | null }, 
    dynamic_template_uuid?: { [mode: number]: string | null },
    id?: number, 
    uuid?: string,
    isDevelopment: boolean = false
  ) {
    this.slug = slug;
    this.id = id;
    this.uuid = uuid || this.generateUUID();
    this.static_template_uuid = static_template_uuid || {1: null, 2: null, 3: null};
    this.dynamic_template_uuid = dynamic_template_uuid || {1: null, 2: null, 3: null};
    this.isDevelopment = isDevelopment;
  }

  private generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }

  //Get specific static template from mode or return nearest available
  public getStaticTemplateFromMode(mode: 1 | 2 | 3): string | null {
    // First try to get the template for the specified mode
    if (this.static_template_uuid && this.static_template_uuid[mode]) {
        return this.static_template_uuid[mode];
    }

    // If no template for specified mode, try fallback modes in order
    if (this.static_template_uuid) {
        for (const fallbackMode of MODE_FALLBACK_ORDER[mode]) {
            if (this.static_template_uuid[fallbackMode]) {
                return this.static_template_uuid[fallbackMode];
            }
        }
    }

    return null;
  }

  //Get specific dynamic template from mode or return nearest available
  public getDynamicTemplateFromMode(mode: 1 | 2 | 3): string | null {
    // First check if we have a template for this mode
    if (this.dynamic_template_uuid && this.dynamic_template_uuid[mode]) {
      return this.dynamic_template_uuid[mode];
    }

    // If no template for specified mode, try fallback modes in order
    if (this.dynamic_template_uuid) {
        for (const fallbackMode of MODE_FALLBACK_ORDER[mode]) {
            if (this.dynamic_template_uuid[fallbackMode]) {
                return this.dynamic_template_uuid[fallbackMode];
            }
        }
    }

    return null;
  }

  //Set static template for mode
  public setStaticTemplateForMode(mode: 1 | 2 | 3, uuid: string) {
    if (!this.static_template_uuid) this.static_template_uuid = [];
    this.static_template_uuid[mode] = uuid;
  }

  //Set dynamic template for mode
  public setDynamicTemplateForMode(mode: 1 | 2 | 3, uuid: string) {
    if (!this.dynamic_template_uuid) this.dynamic_template_uuid = [];
    this.dynamic_template_uuid[mode] = uuid;
  }

  public static convertToDTO(slug: CustomSlug): CustomSlugDTO {
    return {
      id: slug.id || 0,
      uuid: slug.uuid,
      slug: slug.slug,
      static_template_uuid: slug.static_template_uuid || [],
      dynamic_template_uuid: slug.dynamic_template_uuid || [],
      isDevelopment: slug.isDevelopment
    };
  }

  public static fromDTO(dto: CustomSlugDTO): CustomSlug {
      return new CustomSlug(dto.slug, dto.static_template_uuid, dto.dynamic_template_uuid, dto.id, dto.uuid, dto.isDevelopment);
  }
}
